/**
 * Sample files for testing syntax highlighting in the cat command
 * These files demonstrate various programming languages and formats
 */

export const sampleFiles: Record<string, string> = {
  'samples/sample.json': `{
  "name": "Anderson Reinkordt",
  "role": "Full-Stack Developer",
  "skills": ["JavaScript", "TypeScript", "React", "Node.js"],
  "experience": 10,
  "active": true,
  "location": null
}`,
  'samples/sample.md': `# Portfolio Terminal

Welcome to my **interactive** portfolio!

## Features

- Terminal-style interface
- *Syntax highlighting*
- Tab autocomplete
- Session filesystem

### Commands

Try these commands:
- \`help\` - Show all commands
- \`about\` - Learn about me
- \`projects\` - View my work

[Visit my GitHub](https://github.com/username)

\`\`\`javascript
function greet(name) {
  console.log(\`Hello, \${name}!\`);
}
\`\`\`

### Todo List

1. Add more features
2. Improve documentation
3. Deploy to production`,
  'samples/sample.js': `// Sample JavaScript file
import React from 'react'

const API_URL = 'https://api.example.com'
const MAX_RETRIES = 3

/**
 * Fetches user data from API
 * @param {number} userId - The user ID
 * @returns {Promise<Object>} User data
 */
async function fetchUser(userId) {
  try {
    const response = await fetch(\`\${API_URL}/users/\${userId}\`)
    if (!response.ok) {
      throw new Error('Failed to fetch user')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    return null
  }
}

class UserManager {
  constructor(config) {
    this.users = []
    this.config = config
    this.initialized = false
  }

  async init() {
    this.initialized = true
    return this
  }
}

const config = {
  timeout: 5000,
  retries: MAX_RETRIES,
  debug: true
}

export default UserManager`,
  'samples/sample.sh': `#!/bin/bash
# Sample shell script

# Variables
APP_NAME="portfolio"
VERSION="1.0.0"
BUILD_DIR="dist"

# Functions
function build() {
  echo "Building $APP_NAME v$VERSION..."
  npm run build

  if [ $? -eq 0 ]; then
    echo "Build successful!"
    return 0
  else
    echo "Build failed!"
    return 1
  fi
}

function deploy() {
  local env=$1
  echo "Deploying to $env..."

  # Export environment variables
  export NODE_ENV=$env
  export API_URL=\${API_URL:-"https://api.example.com"}

  # Run deployment
  cd $BUILD_DIR && npm start
}

# Main execution
case "$1" in
  build)
    build
    ;;
  deploy)
    deploy "$2"
    ;;
  *)
    echo "Usage: $0 {build|deploy <env>}"
    exit 1
    ;;
esac`,
}
